import React from "react";
import styles from './LocationTime.module.scss'
import moment from 'moment';
import {ITicketDetailsWithTerms} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';

export interface ILocationTime {
  ticketDetails: ITicketDetailsWithTerms;
  fromDestination?: boolean;
  flip?: boolean;
  style: any;
}


const LocationTime = (props: ILocationTime) => {
  const timeOfTakeOff = props.fromDestination ? props.ticketDetails.destinationTimeOfTakeOff : props.ticketDetails.originTimeOfTakeOff;
  const timeOfLanding = props.fromDestination ? props.ticketDetails.destinationTimeOfLanding : props.ticketDetails.originTimeOfLanding;
  const originAirport = props.fromDestination ? props.ticketDetails.destinationAirport : props.ticketDetails.originAirport;
  const destinationAirport = props.fromDestination ? props.ticketDetails.originAirport : props.ticketDetails.destinationAirport;
  const city = (props.flip ? destinationAirport : originAirport).city;
  const iata = (props.flip ? destinationAirport : originAirport).iata;
  return (
    <div
      className={`${styles.locationTime} ${props.flip ? ` ${styles.flip}` : ""}`}
      style={{
        ...props.style
      }}
    >
      <h5 className={styles.time}>{moment(props.flip ? timeOfLanding : timeOfTakeOff).format('HH:mm')}</h5>
      <h5
        className={`${styles.iata} disableWordBreak`}
        title={city}
      >
        {iata}
      </h5>
      <small
        style={{display: 'none'}}
        className={`${styles.city} disableWordBreak`}
      >{city}
      </small>
    </div>
  )
};

LocationTime.defaultProps = {
  fromDestination: false,
  style: {},
};

export default LocationTime;
